<div class="progressContainer">
    <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <div class="header hdr d-flex">
        <h5 class="progressH5"><span class="animateH5">Progress</span></h5>
        <p class="text-center notify" *ngIf="progressTableData.length !== 0">List will auto refresh every 10 seconds <i
                class="fa fa-refresh fa-spin"></i>
            <span class="sr-only">Loading...</span>
        </p>

    </div>
    <div class="container-fluid">
        <div class="card tblCrd">
            <div class="table-responsive">
                <table class="table text-center table-striped">
                    <thead class="tblHead">
                        <tr>
                            <th>USER ID</th>
                            <th>QUEUE/TOPIC</th>
                            <th>STATUS</th>
                            <th>TIMESTAMP</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of progressTableData">
                            <td>{{userDetails[0]?.email}}</td>
                            <td>{{data?.file_name}}</td>
                            <td>{{data?.status}}</td>
                            <td>{{data?.time_stamp | date:'medium'}}</td>
                            <td><i class="fa fa-circle-notch fa-spin"></i>
                                <span class="sr-only">Loading...</span>
                            </td>
                        </tr>
                        <tr class="text-center" *ngIf="progressTableData.length === 0 && !bodySpinner">
                            <td colspan="9">
                                <p class="noRecord">No files are currently in progress</p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>